import { TAG_CODES } from "../../tag.config"

const GOM_POINT_WATER_AERIAL = {
    type: 'path',
    tagCode: TAG_CODES.RESOURCE,
    withText: true,
    defaultText: 'Water air',
    positionText: 'top', // top - right - center - bottom - left
    fieldsText: ["title"],
    endTextWidthStr: "",
    angle: 0,
    colorCodeId: 'water',
    withFillColor: true,
    schema: {
        "type": 'object',
        "properties": {
            "title": {
                "title": "Text",
                "description": "Write a text",
                "type": "string",
            },
        },
        "required": []
    },
    pathData: `M48 8A40 40 90 1147.992 8ZM24 32 24 64 48 48ZM72 32 48 48 72 64Z`,   
}

export default GOM_POINT_WATER_AERIAL